export default {
  // btnAnimation: '',
  mouseDown: false,
  // ctxButtons: null,
  weatherData: false,
  // dayPart: 'day',
  currentEvent: '',

  currentEventData: {},

  events: [],

  eventsList: null,

  lang: 'it',

  changeLang: false,

  hoverEvent: false,

  ctxButtons: null,

  allLoaded: false,
};



// WEBPACK FOOTER //
// ./src/store/state.js